import { render, staticRenderFns } from "./ProductAfterSales.vue?vue&type=template&id=717a662a&scoped=true&"
import script from "./ProductAfterSales.vue?vue&type=script&lang=js&"
export * from "./ProductAfterSales.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "717a662a",
  null
  
)

export default component.exports